import store from '../store/index'
import { createRouter, createWebHistory } from "vue-router";
import Login from "../components/Login.vue";
import Logout from "../../src/components/Logout.vue";
import Verify from "../../src/components/Verify.vue";
import ForgetPassword from "../modules/forgetPassword/ForgetPassword.vue";
import userProfile from "../modules/users/UserProfile.vue";
import InProgress from "../components/ui/InProgress.vue";
import Verification from "../modules/verification/Verification.vue";
import user from "../modules/users/User.vue";
import Loader from "../components/ui/Loader.vue"
import ShowReports from '../components/ShowReports.vue'
import Contact from '@/modules/Contact/Contact.vue';
import ClientDetails from '@/modules/ClientDetails/index.vue'
import WorkTimingSelection from '../modules/settings/Organization/WorkTimings/WorkTimingSelection.vue'
import CreateException from '@/modules/CreateException/CreateException.vue';
import ClientTable from '@/modules/ClientDetails/ClientTable.vue';
import Organisation from '@/modules/Organisation/Organisation.vue';
import ClientLocations from '@/modules/ClientLocations/ClientLocations.vue';
import AboutClient from '@/modules/AboutClient/AboutClient.vue';
import CoreforceTeam from '@/CoreforceTeam/CoreforceTeam.vue';
import KnowProduct from '@/KnowProduct/KnowProduct.vue'
import UploadOrganisation from '@/menus/AboutClient/UploadOrganisation.vue';
import Customers from '@/modules/Customers/Customers.vue';
import ShippingDetails from '@/modules/ShippingsDetails/ShippingDetails.vue';
import Wareouse from '@/modules/Wareouse/Wareouse.vue';
import Factories from '@/modules/Factories/Factories.vue';
import Process from '@/modules/Process/Process.vue';
import Exceptions from '@/modules/Exceptions/Exceptions.vue';
import Watch from '@/modules/WatchDOC/Watch.vue';
import Alerts from '@/modules/Alerts/Alerts.vue';
import Images from '@/modules/Images/images.vue';
import CustomerAlerts from '@/modules/Alerts/CustomerAlerts.vue';
import WareHouseMenu from '@/modules/Wareouse/WareHouseMenu.vue';
import ProcessFlow from '@/modules/ProcessFlow/ProcessFlow.vue';
import DataModelList from '@/modules/Data Model/dataModelList.vue';
import CreateDataModel from '@/modules/Data Model/CreateDataModel.vue';
import DataModelMain from '@/modules/Data Model/dataModelMain.vue';
import Details from '@/modules/Data Model/Details.vue';
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/verify",
    name: "verify",
    component: Verify,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: '/uploadExcel',
    name: "ExcelUpload",
    component: UploadOrganisation,
  },
  {
    path: '/datamodel',
    name: "DataModel",
    component: DataModelList,
  },
  {
    path: '/addmodel',
    name: "AddModel",
    component: CreateDataModel,
  },

  {
    path: '/editmodel',
    name: "EditModel",
    component: DataModelMain,
  },
  {
    path: '/details',
    name: "Details",
    component: Details,
  },
  {
    path: "/showReports",
    name: "showReports",
    component: ShowReports,
  },
  {
    path: "/userProfile",
    name: "userProfile",
    component: userProfile,
  },
  {
    path: "/",
    name: "ClientTable",
    component: ClientTable,
  },
  {
    path: "/ClientDetails",
    name: "ClientDetails",
    component: ClientDetails,
    children: [
      {
        path: "aboutclient",
        name: "Aboutclients",
        component: AboutClient,
      },
      {
        path: "organisation",
        name: "Organisation",
        component: Organisation,
      },
      {
        path: "locations",
        name: "Locations",
        component: ClientLocations,
      },
      {
        path: "coreforceteam",
        name: "CoreforceTeam",
        component: CoreforceTeam,
      },
      {
        path: "knowyourproduct",
        name: "KnowProduct",
        component: KnowProduct,
      },
      {
        path: "customers",
        name: "Customers",
        component: Customers,
      },
      {
        path: "routinginformation",
        name: "ShippingDetails",
        component: ShippingDetails,
      },
      {
        path: "wareouse",
        name: "Wareouse",
        component: Wareouse,
      },

       {
        path: "warehouse",
        name: "Warehouse",
        component: WareHouseMenu,
      },

      {
        path:"factories",
        name:'Factories',
        component: Factories,
      },
      {
        path:'process&sop',
        name:'Process',
        component: Process,
      },
      {
        path:'exceptions',
        name:'Exceptions',
        component: Exceptions,
      },
      {
        path:'watchdoc',
        name:'Watchdoc',
        component: Watch,
      },
      {
        path:'alerts',
        name:'Alerts',
        component: Alerts,
      },
      {
        path:'commonalerts',
        name:'Commonalerts',
        component: Alerts,
      },
      {
        path:'customeralerts',
        name:'Customeralerts',
        component: CustomerAlerts,
      },
      {
        path:'images',
        name:'Images',
        component: Images,
      },
      {
        path:'processflow',
        name:'ProcessFlow',
        component: ProcessFlow,
      },
    ],
  },
  {
    path: "/ForgetPassword",
    name: "ForgetPassword",
    component: ForgetPassword,
  },
  {
    path: "/user",
    name: "User",
    component: user,
  },
  {
    path: "/notFound",
    name: "Improgress",
    component: InProgress,
  },
  {
    path: "/verifyUser",
    name: "Verification",
    component: Verification,
  },
  {
    path: "/loader",
    name: "Loader",
    component: Loader,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: '/autoSuggest',
    name: 'WorkTimingSelection',
    component: WorkTimingSelection
  },
  {
    path: "/createException",
    name: "createException",
    component: CreateException,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
const publicPages = ["/login", "/verify", "/accountVerification"];

router.beforeEach((to, from, next) => {
  console.log(to,"checking route")
  const $token = localStorage.getItem("TOKEN");
  const deviceId = localStorage.getItem('deviceId')
  store.commit('SET_DEVICE_ID',deviceId);
  if (publicPages.includes(to.path)) {
    return next();
  }
 
  if ($token) {
    console.log($token,"$token!!!")
    let $workTiming = localStorage.getItem('_WORK_TIMING_')
    console.log($workTiming,'$workTiming!!!')
    console.log(to.path,"to.path!!!")
    // if(!$workTiming && to.path!='/autoSuggest' && to.path!='/notFound') {
    //  // alert('routing'+to.path)
    //   return next("/autoSuggest");
    // }
    let $timer = JSON.parse(localStorage.getItem("timer"))
    let $listBoard = localStorage.getItem("issueDisplay")
    if($listBoard){
      store.commit("SET_ISSUE_DISPLAY", $listBoard=='true' ? true : false)
    }
    //let timerData = JSON.parse(localStorage.getItem("breakormeeting"))
    if ($timer) {
      store.commit('SET_IN_PROGRESS', true)
    }
    else {
      store.commit('SET_IN_PROGRESS', false)
    }
    if (to.matched.length == 0) {
     
      return next("/notFound");
    } else {
      return next();
    }
  } else {
    return next("/login");
  }
});

export default router;
